<form [formGroup]="form" (ngSubmit)="onSubmit()" class="ts-form-card">

  <div class="ts-form-grid" [class.ts-form-grid--3col]="needsUrl">

    <div class="field-content">
      <one-select
        label="Tipo de campaña"
        [dataSource]="campaignTypes"
        [disabled]="loading"
        (selectionChanged)="onTypeSelect($event)"
      ></one-select>
    </div>

    <div class="field-content">
      <one-input
        label="Campaign ID"
        formControlName="campaignId"
        placeholder="SAC-01KKA6AZ8CWG4JDPB8N2FJ5P19"
        autocomplete="off"
        appFormErrors
      ></one-input>
    </div>

    <div *ngIf="needsUrl" class="field-content">
      <one-input
        label="Store URL"
        formControlName="storeUrl"
        placeholder="https://www.rappi.com.mx/tiendas/1930344693-chiper-express"
        autocomplete="off"
      ></one-input>
    </div>

  </div>

  <div class="ts-form-bottom">
    <div *ngIf="needsKeyword; else emptySlot" class="field-content ts-keyword-field">
      <one-input
        label="Keyword (opcional)"
        formControlName="keyword"
        placeholder="queso"
        autocomplete="off"
      ></one-input>
    </div>
    <ng-template #emptySlot><div></div></ng-template>

    <div class="ts-actions">
      <button type="submit" class="rp-button rp-filled rp-primary rp-small" [disabled]="!canSubmit">
        <ng-container *ngIf="loading; else submitLabel">
          <svg class="ts-spinner" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25"/>
            <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
          </svg>
          Analizando...
        </ng-container>
        <ng-template #submitLabel>Diagnosticar</ng-template>
      </button>
    </div>
  </div>

  <div *ngIf="needsUrl && storeUrl" class="ts-url-preview">
    <ng-container *ngIf="parsedUrl.ok; else urlError">
      <span class="ts-parse-chip">
        <span class="ts-parse-chip__label">Store ID:</span>
        <code class="ts-parse-chip__value">{{ parsedUrl.storeId }}</code>
      </span>
      <span class="ts-parse-chip">
        <span class="ts-parse-chip__label">Store type:</span>
        <code class="ts-parse-chip__value">{{ parsedUrl.storeType }}</code>
      </span>
    </ng-container>
    <ng-template #urlError>
      <span class="ts-url-error">
        <span class="one-icon-alert-rounded"></span>
        {{ parsedUrl.error }}
      </span>
    </ng-template>
  </div>

</form>
